export const TESTID_PORTFOLIO_WIDGET = 'portfolio-widget';
export const TESTID_PORTFOLIO_WIDGET_RECALCULATE_ALLOCATIONS_BUTTON = `${TESTID_PORTFOLIO_WIDGET}-recalculate-allocations-button`;
export const TESTID_PORTFOLIO_WIDGET_CONFIRM_ALLOCATIONS_BUTTON = `${TESTID_PORTFOLIO_WIDGET}-confirm-allocations-button`;
export const TESTID_PORTFOLIO_WIDGET_RESET_CUSTOM_ALLOCATIONS_BUTTON = `${TESTID_PORTFOLIO_WIDGET}-reset-custom-allocations-button`;
export const TESTID_PORTFOLIO_WIDGET_SECURITIES_TABLE_HEAD_CELL = (
  cell: string,
) => `${TESTID_PORTFOLIO_WIDGET}-securities-table-head-cell-${cell}`;
export const TESTID_PORTFOLIO_WIDGET_SECURITIES_TABLE_ROW = (index: number) =>
  `${TESTID_PORTFOLIO_WIDGET}-securities-table-row-${index}`;
export const TESTID_PORTFOLIO_WIDGET_SECURITIES_TABLE_ROW_CELL = (
  index: number,
  cell: string,
) => `${TESTID_PORTFOLIO_WIDGET}-securities-table-row-${index}-cell-${cell}`;
export const TESTID_PORTFOLIO_WIDGET_HOLDINGS_TABLE_HEAD_CELL = (
  index: number,
) => `${TESTID_PORTFOLIO_WIDGET}-holdings-table-head-cell-${index}`;
export const TESTID_PORTFOLIO_WIDGET_HOLDINGS_TABLE_ROW = (index: number) =>
  `${TESTID_PORTFOLIO_WIDGET}-holdings-table-row-${index}`;
export const TESTID_PORTFOLIO_WIDGET_HOLDINGS_TABLE_ROW_CELL = (
  index: number,
  cellSubIndex: string | number,
) =>
  `${TESTID_PORTFOLIO_WIDGET}-holdings-table-row-${index}-cell-${cellSubIndex}`;
